import { useEffect, useRef, useState } from 'react'
import { DateRange } from 'react-date-range'
import format from 'date-fns/format'
import { addDays } from 'date-fns'
import { enUS } from 'date-fns/locale'

import 'react-date-range/dist/styles.css'
import 'react-date-range/dist/theme/default.css'

const DateTimeRangePickerComponent = ({ onChange, clear }) => {
  const [range, setRange] = useState([
    {
      startDate: null,
      endDate: null,
      key: 'selection',
    },
  ])

  const [open, setOpen] = useState(false)
  const refOne = useRef(null)

  useEffect(() => {
    document.addEventListener('keydown', hideOnEscape, true)
    document.addEventListener('click', hideOnClickOutside, true)
    return () => {
      document.removeEventListener('keydown', hideOnEscape, true)
      document.removeEventListener('click', hideOnClickOutside, true)
    }
  }, [])

  const hideOnEscape = (e) => {
    if (e.key === 'Escape') {
      setOpen(false)
    }
  }

  const hideOnClickOutside = (e) => {
    if (refOne.current && !refOne.current.contains(e.target)) {
      setOpen(false)
    }
  }

  const handleSelect = (item) => {
    const selectedRange = item.selection
    setRange([selectedRange])

    const formattedRange = [selectedRange.startDate, selectedRange.endDate]
    onChange(formattedRange)
  }

  useEffect(() => {
    if (clear) {
      setRange([
        {
          startDate: null,
          endDate: null,
          key: 'selection',
        },
      ])
    }
  }, [clear])

  return (
    <div className="calendarWrap">
      <textarea
        value={
          range[0]?.startDate && range[0]?.endDate
            ? `${format(range[0].startDate, 'dd MMM yyyy HH:mm:ss')}\n${format(
                range[0].endDate,
                'dd MMM yyyy HH:mm:ss'
              )}`
            : ''
        }
        readOnly
        rows={2}
        style={{
          width: '100%',
          padding: '3px',
          fontSize: '10px',
          lineHeight: '1.5',
          border: '1px solid #ccc',
          borderRadius: '4px',
          resize: 'none',
          overflow: 'hidden',
          backgroundColor: 'white',
          marginTop: '3px',
          color: 'secondary',
          outline: 'blue',
          textAlign: 'center',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
        placeholder="Select Date Range"
        onClick={() => setOpen((open) => !open)}
      />

      <div ref={refOne}>
        {open && (
          <DateRange
            onChange={handleSelect}
            editableDateInputs={true}
            moveRangeOnFirstSelection={false}
            ranges={range}
            months={1}
            direction="horizontal"
            locale={enUS}
            className="calendarElement"
          />
        )}
      </div>
    </div>
  )
}

export default DateTimeRangePickerComponent
